// Shared types for the AI categorization fields feedback-categorization-service
// writes onto the feedback table and FeedbackPromptResponsesTable items. Mirrors
// FeedbackCategory/FeedbackSentiment/FeedbackUrgency in the backend's aiProvider.ts.

export type FeedbackCategory = 'bug' | 'feature_request' | 'ux_confusion' | 'praise' | 'question' | 'other';
export type FeedbackSentiment = 'positive' | 'neutral' | 'negative';
export type FeedbackUrgency = 'low' | 'medium' | 'high';

export interface AiCategorizationFields {
    aiCategory?: FeedbackCategory;
    aiSentiment?: FeedbackSentiment;
    aiUrgency?: FeedbackUrgency;
    aiSummary?: string;
    aiCategorizedAt?: string;
}

export const CATEGORY_LABELS: Record<FeedbackCategory, string> = {
    bug: 'Bug',
    feature_request: 'Feature Request',
    ux_confusion: 'UX Confusion',
    praise: 'Praise',
    question: 'Question',
    other: 'Other',
};

export const SENTIMENT_LABELS: Record<FeedbackSentiment, string> = {
    positive: 'Positive',
    neutral: 'Neutral',
    negative: 'Negative',
};

export const URGENCY_LABELS: Record<FeedbackUrgency, string> = {
    high: 'High',
    medium: 'Medium',
    low: 'Low',
};

export const URGENCY_COLORS: Record<FeedbackUrgency, string> = {
    high: '#dc2626',
    medium: '#d97706',
    low: '#65a30d',
};

export const SENTIMENT_COLORS: Record<FeedbackSentiment, string> = {
    positive: '#16a34a',
    neutral: '#6b7280',
    negative: '#dc2626',
};
